// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"167":"75970606","229":"8bda9ad9","921":"0cc406aa"}[chunkId] + ".css";
};